"use strict";

// Copyright 2018 Google LLC
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//    http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var _asyncToGenerator = require("/codebuild/output/src4083160994/src/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");
var _classCallCheck = require("/codebuild/output/src4083160994/src/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/codebuild/output/src4083160994/src/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Gaxios = void 0;
var extend_1 = __importDefault(require("extend"));
var https_1 = require("https");
var node_fetch_1 = __importDefault(require("node-fetch"));
var querystring_1 = __importDefault(require("querystring"));
var is_stream_1 = __importDefault(require("is-stream"));
var url_1 = require("url");
var common_1 = require("./common");
var retry_1 = require("./retry");
/* eslint-disable @typescript-eslint/no-explicit-any */
var fetch = hasFetch() ? window.fetch : node_fetch_1.default;
function hasWindow() {
  return typeof window !== 'undefined' && !!window;
}
function hasFetch() {
  return hasWindow() && !!window.fetch;
}
function hasBuffer() {
  return typeof Buffer !== 'undefined';
}
function hasHeader(options, header) {
  return !!getHeader(options, header);
}
function getHeader(options, header) {
  header = header.toLowerCase();
  for (var _i = 0, _Object$keys = Object.keys((options === null || options === void 0 ? void 0 : options.headers) || {}); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    if (header === key.toLowerCase()) {
      return options.headers[key];
    }
  }
  return undefined;
}
var HttpsProxyAgent;
function loadProxy() {
  var proxy = process.env.HTTPS_PROXY || process.env.https_proxy || process.env.HTTP_PROXY || process.env.http_proxy;
  if (proxy) {
    HttpsProxyAgent = require('https-proxy-agent');
  }
  return proxy;
}
loadProxy();
function skipProxy(url) {
  var _a;
  var noProxyEnv = (_a = process.env.NO_PROXY) !== null && _a !== void 0 ? _a : process.env.no_proxy;
  if (!noProxyEnv) {
    return false;
  }
  var noProxyUrls = noProxyEnv.split(',');
  var parsedURL = new url_1.URL(url);
  return !!noProxyUrls.find(function (url) {
    if (url.startsWith('*.') || url.startsWith('.')) {
      url = url.replace(/^\*\./, '.');
      return parsedURL.hostname.endsWith(url);
    } else {
      return url === parsedURL.origin || url === parsedURL.hostname;
    }
  });
}
// Figure out if we should be using a proxy. Only if it's required, load
// the https-proxy-agent module as it adds startup cost.
function getProxy(url) {
  // If there is a match between the no_proxy env variables and the url, then do not proxy
  if (skipProxy(url)) {
    return undefined;
    // If there is not a match between the no_proxy env variables and the url, check to see if there should be a proxy
  } else {
    return loadProxy();
  }
}
var Gaxios = /*#__PURE__*/function () {
  /**
   * The Gaxios class is responsible for making HTTP requests.
   * @param defaults The default set of options to be used for this instance.
   */
  function Gaxios(defaults) {
    _classCallCheck(this, Gaxios);
    this.agentCache = new Map();
    this.defaults = defaults || {};
  }
  /**
   * Perform an HTTP request with the given options.
   * @param opts Set of HTTP options that will be used for this HTTP request.
   */
  _createClass(Gaxios, [{
    key: "request",
    value: function () {
      var _request2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var opts,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              opts = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              opts = this.validateOpts(opts);
              return _context.abrupt("return", this._request(opts));
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function request() {
        return _request2.apply(this, arguments);
      }
      return request;
    }()
  }, {
    key: "_defaultAdapter",
    value: function () {
      var _defaultAdapter2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(opts) {
        var fetchImpl, res, data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              fetchImpl = opts.fetchImplementation || fetch;
              _context2.next = 3;
              return fetchImpl(opts.url, opts);
            case 3:
              res = _context2.sent;
              _context2.next = 6;
              return this.getResponseData(opts, res);
            case 6:
              data = _context2.sent;
              return _context2.abrupt("return", this.translateResponse(opts, res, data));
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function _defaultAdapter(_x) {
        return _defaultAdapter2.apply(this, arguments);
      }
      return _defaultAdapter;
    }()
    /**
     * Internal, retryable version of the `request` method.
     * @param opts Set of HTTP options that will be used for this HTTP request.
     */
  }, {
    key: "_request",
    value: function () {
      var _request3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var opts,
          translatedResponse,
          err,
          _yield$retry_1$getRet,
          shouldRetry,
          config,
          _args3 = arguments;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              opts = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
              _context3.prev = 1;
              if (!opts.adapter) {
                _context3.next = 8;
                break;
              }
              _context3.next = 5;
              return opts.adapter(opts, this._defaultAdapter.bind(this));
            case 5:
              translatedResponse = _context3.sent;
              _context3.next = 11;
              break;
            case 8:
              _context3.next = 10;
              return this._defaultAdapter(opts);
            case 10:
              translatedResponse = _context3.sent;
            case 11:
              if (opts.validateStatus(translatedResponse.status)) {
                _context3.next = 13;
                break;
              }
              throw new common_1.GaxiosError("Request failed with status code ".concat(translatedResponse.status), opts, translatedResponse);
            case 13:
              return _context3.abrupt("return", translatedResponse);
            case 16:
              _context3.prev = 16;
              _context3.t0 = _context3["catch"](1);
              err = _context3.t0;
              err.config = opts;
              _context3.next = 22;
              return retry_1.getRetryConfig(_context3.t0);
            case 22:
              _yield$retry_1$getRet = _context3.sent;
              shouldRetry = _yield$retry_1$getRet.shouldRetry;
              config = _yield$retry_1$getRet.config;
              if (!(shouldRetry && config)) {
                _context3.next = 28;
                break;
              }
              err.config.retryConfig.currentRetryAttempt = config.retryConfig.currentRetryAttempt;
              return _context3.abrupt("return", this._request(err.config));
            case 28:
              throw err;
            case 29:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1, 16]]);
      }));
      function _request() {
        return _request3.apply(this, arguments);
      }
      return _request;
    }()
  }, {
    key: "getResponseData",
    value: function () {
      var _getResponseData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(opts, res) {
        var data;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.t0 = opts.responseType;
              _context4.next = _context4.t0 === 'stream' ? 3 : _context4.t0 === 'json' ? 4 : _context4.t0 === 'arraybuffer' ? 9 : _context4.t0 === 'blob' ? 10 : 11;
              break;
            case 3:
              return _context4.abrupt("return", res.body);
            case 4:
              _context4.next = 6;
              return res.text();
            case 6:
              data = _context4.sent;
              try {
                data = JSON.parse(data);
              } catch (_a) {
                // continue
              }
              return _context4.abrupt("return", data);
            case 9:
              return _context4.abrupt("return", res.arrayBuffer());
            case 10:
              return _context4.abrupt("return", res.blob());
            case 11:
              return _context4.abrupt("return", res.text());
            case 12:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function getResponseData(_x2, _x3) {
        return _getResponseData.apply(this, arguments);
      }
      return getResponseData;
    }()
    /**
     * Validates the options, and merges them with defaults.
     * @param opts The original options passed from the client.
     */
  }, {
    key: "validateOpts",
    value: function validateOpts(options) {
      var opts = extend_1.default(true, {}, this.defaults, options);
      if (!opts.url) {
        throw new Error('URL is required.');
      }
      // baseUrl has been deprecated, remove in 2.0
      var baseUrl = opts.baseUrl || opts.baseURL;
      if (baseUrl) {
        opts.url = baseUrl + opts.url;
      }
      opts.paramsSerializer = opts.paramsSerializer || this.paramsSerializer;
      if (opts.params && Object.keys(opts.params).length > 0) {
        var additionalQueryParams = opts.paramsSerializer(opts.params);
        if (additionalQueryParams.startsWith('?')) {
          additionalQueryParams = additionalQueryParams.slice(1);
        }
        var prefix = opts.url.includes('?') ? '&' : '?';
        opts.url = opts.url + prefix + additionalQueryParams;
      }
      if (typeof options.maxContentLength === 'number') {
        opts.size = options.maxContentLength;
      }
      if (typeof options.maxRedirects === 'number') {
        opts.follow = options.maxRedirects;
      }
      opts.headers = opts.headers || {};
      if (opts.data) {
        var isFormData = typeof FormData === 'undefined' ? false : (opts === null || opts === void 0 ? void 0 : opts.data) instanceof FormData;
        if (is_stream_1.default.readable(opts.data)) {
          opts.body = opts.data;
        } else if (hasBuffer() && Buffer.isBuffer(opts.data)) {
          // Do not attempt to JSON.stringify() a Buffer:
          opts.body = opts.data;
          if (!hasHeader(opts, 'Content-Type')) {
            opts.headers['Content-Type'] = 'application/json';
          }
        } else if (typeof opts.data === 'object') {
          // If www-form-urlencoded content type has been set, but data is
          // provided as an object, serialize the content using querystring:
          if (!isFormData) {
            if (getHeader(opts, 'content-type') === 'application/x-www-form-urlencoded') {
              opts.body = opts.paramsSerializer(opts.data);
            } else {
              // } else if (!(opts.data instanceof FormData)) {
              if (!hasHeader(opts, 'Content-Type')) {
                opts.headers['Content-Type'] = 'application/json';
              }
              opts.body = JSON.stringify(opts.data);
            }
          }
        } else {
          opts.body = opts.data;
        }
      }
      opts.validateStatus = opts.validateStatus || this.validateStatus;
      opts.responseType = opts.responseType || 'json';
      if (!opts.headers['Accept'] && opts.responseType === 'json') {
        opts.headers['Accept'] = 'application/json';
      }
      opts.method = opts.method || 'GET';
      var proxy = getProxy(opts.url);
      if (proxy) {
        if (this.agentCache.has(proxy)) {
          opts.agent = this.agentCache.get(proxy);
        } else {
          // Proxy is being used in conjunction with mTLS.
          if (opts.cert && opts.key) {
            var parsedURL = new url_1.URL(proxy);
            opts.agent = new HttpsProxyAgent({
              port: parsedURL.port,
              host: parsedURL.host,
              protocol: parsedURL.protocol,
              cert: opts.cert,
              key: opts.key
            });
          } else {
            opts.agent = new HttpsProxyAgent(proxy);
          }
          this.agentCache.set(proxy, opts.agent);
        }
      } else if (opts.cert && opts.key) {
        // Configure client for mTLS:
        if (this.agentCache.has(opts.key)) {
          opts.agent = this.agentCache.get(opts.key);
        } else {
          opts.agent = new https_1.Agent({
            cert: opts.cert,
            key: opts.key
          });
          this.agentCache.set(opts.key, opts.agent);
        }
      }
      return opts;
    }
    /**
     * By default, throw for any non-2xx status code
     * @param status status code from the HTTP response
     */
  }, {
    key: "validateStatus",
    value: function validateStatus(status) {
      return status >= 200 && status < 300;
    }
    /**
     * Encode a set of key/value pars into a querystring format (?foo=bar&baz=boo)
     * @param params key value pars to encode
     */
  }, {
    key: "paramsSerializer",
    value: function paramsSerializer(params) {
      return querystring_1.default.stringify(params);
    }
  }, {
    key: "translateResponse",
    value: function translateResponse(opts, res, data) {
      // headers need to be converted from a map to an obj
      var headers = {};
      res.headers.forEach(function (value, key) {
        headers[key] = value;
      });
      return {
        config: opts,
        data: data,
        headers: headers,
        status: res.status,
        statusText: res.statusText,
        // XMLHttpRequestLike
        request: {
          responseURL: res.url
        }
      };
    }
  }]);
  return Gaxios;
}();
exports.Gaxios = Gaxios;